/**
 * @generated SignedSource<<5297273c14d58e0a3778af994cecdb9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetDisplaySeriesItemResult$data = ReadonlyArray<{
  readonly entityId?: string;
  readonly urlAlias?: string;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetItemContent">;
  readonly " $fragmentType": "seriesWidgetDisplaySeriesItemResult";
}>;
export type seriesWidgetDisplaySeriesItemResult$key = ReadonlyArray<{
  readonly " $data"?: seriesWidgetDisplaySeriesItemResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetDisplaySeriesItemResult">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "seriesWidgetDisplaySeriesItemResult",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "seriesWidgetItemContent"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "SeriesItemResult",
  "abstractKey": "__isSeriesItemResult"
};

(node as any).hash = "24993a61338731f38529c3cb3ebd7798";

export default node;
